const scrollTextContent = "https://cdn.shopify.com/s/files/1/0759/2250/6023/files/click-to-play-with-globe.png?v=1690598009";

const scrollTextGlob = "https://cdn.shopify.com/s/files/1/0759/2250/6023/files/globe-new.png?v=1690523262";

const mediaDivs = document.querySelectorAll(".index-first-banner");

const parentBanner = document.getElementById("Banner-template--18974250074407__d288b5e0-994a-4c1f-98dc-a67d75a1e9de");

const mediaDiv = document.querySelector("#Banner-template--18974250074407__d288b5e0-994a-4c1f-98dc-a67d75a1e9de .banner__media");

addSwipeBtns();
scrollTextAnimation();
attachVideo();

function addSwipeBtns() {
  const swipeBtns = document.createElement("div");
  swipeBtns.className = "swipeBtns";
  swipeBtns.innerHTML = '<a href="#slide-1"></a><a href="#slide-2"></a>';

  mediaDivs[0].appendChild(swipeBtns);
}


// functions
function scrollTextAnimation() {

  let wrapperDiv = document.createElement("div");
  wrapperDiv.id = "textScroll";

  imgDiv1 = document.createElement("img");
  imgDiv2 = document.createElement("img");
  imgDiv3 = document.createElement("img");
  imgDiv4 = document.createElement("img");
  imgDiv5 = document.createElement("img");
  imgDiv6 = document.createElement("img");
  imgDiv7 = document.createElement("img");
  imgDiv8 = document.createElement("img");

  imgDiv1.src = scrollTextContent;
  imgDiv2.src = scrollTextContent;
  imgDiv3.src = scrollTextContent;
  imgDiv4.src = scrollTextContent;
  imgDiv5.src = scrollTextContent;
  imgDiv6.src = scrollTextContent;
  imgDiv7.src = scrollTextContent;
  imgDiv8.src = scrollTextContent;
  // first batch
  wrapperDiv.appendChild(imgDiv1);
  wrapperDiv.appendChild(imgDiv2);
  wrapperDiv.appendChild(imgDiv3);
  wrapperDiv.appendChild(imgDiv4);
  wrapperDiv.appendChild(imgDiv5);
  wrapperDiv.appendChild(imgDiv6);
  wrapperDiv.appendChild(imgDiv7);
  wrapperDiv.appendChild(imgDiv8);

  parentBanner.insertBefore(wrapperDiv, mediaDiv)
}

function attachVideo() {
  let rightHalf = document.querySelector(
    "#Banner-template--18974250074407__d288b5e0-994a-4c1f-98dc-a67d75a1e9de .banner__media-half-right"
  );
  rightHalf.removeChild(rightHalf.firstElementChild);
  let videoDiv =
    "<video autoplay muted playsinline controls='controls' style='object-fit:cover' poster='https://cdn.shopify.com/s/files/1/0759/2250/6023/files/bg4_2x_725badb0-3289-49b2-91e5-c6339672141a.png?v=1688393918'><source src='https://cdn.shopify.com/videos/c/o/v/82826cda5b154bf3baf2762804785c77.mp4' type='video/mp4'></video>";
  rightHalf.innerHTML = videoDiv;
}

mediaDivs[0].addEventListener("touchstart", startTouch, false);
mediaDivs[0].addEventListener("touchmove", moveTouch, false);

// Swipe Up / Down / Left / Right
var initialX = null;
var initialY = null;

function startTouch(e) {
  initialX = e.touches[0].clientX;
  initialY = e.touches[0].clientY;
}

/*
function moveTouch(e) {
  if (initialX === null) {
    return;
  }

  if (initialY === null) {
    return;
  }

  var currentX = e.touches[0].clientX;
  var currentY = e.touches[0].clientY;

  var diffX = initialX - currentX;
  var diffY = initialY - currentY;

  if (Math.abs(diffX) > Math.abs(diffY)) {
    // sliding horizontally
    if (diffX > 0) {
      // swiped left
      console.log("swiped left");
      // mediaDivs[0].
    } else {
      // swiped right
      console.log("swiped right");
    }
  } else {
    // sliding vertically
    if (diffY > 0) {
      // swiped up
      console.log("swiped up");
    } else {
      // swiped down
      console.log("swiped down");
    }
  }

  initialX = null;
  initialY = null;

  e.preventDefault();
}
*/


















